import { render, staticRenderFns } from "./FilterFacet.vue?vue&type=template&id=64a4f6e9&scoped=true&"
import script from "./FilterFacet.vue?vue&type=script&lang=ts&"
export * from "./FilterFacet.vue?vue&type=script&lang=ts&"
import style0 from "./FilterFacet.vue?vue&type=style&index=0&id=64a4f6e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4f6e9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCross24px: require('/var/www/packages/theme/components/icons/cross/Cross24px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsChip: require('/var/www/packages/theme/components/atoms/Chip.vue').default,MoleculesSearchFilter: require('/var/www/packages/theme/components/molecules/SearchFilter.vue').default,MoleculesPriceFilter: require('/var/www/packages/theme/components/molecules/PriceFilter.vue').default,AtomsCounter: require('/var/www/packages/theme/components/atoms/Counter.vue').default})
